import { Button, CircularProgress } from "@mui/material";
import classNames from "classnames";
import Input from "pages/test_manager/components/Input";
import Select from "pages/test_manager/components/Input/Select";
import { useEffect, useState } from "react";
import { apiGet, apiPost, apiPut } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { useNavigate, useParams } from "react-router-dom";

export default function AddEditBankPage() {
  const { id } = useParams();
  const notification = useToastContext();
  const [formData, setFormData] = useState({
    bankName: "",
    bankNameAr: "",
    accountName: "",
    accountNameAr: "",
    ibanNo: "",
    // status: "active",
  });
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(!!id);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchBank = async () => {
      setLoading(true);
      if (!id) {
        setLoading(false);
        setIsEdit(false);
        return;
      }
      try {
        const response = await apiGet(`${apiPath.banks}/${id}`);
        if (response?.data?.results) {
          setFormData(response?.data?.results);
        }
      } catch (error) {
        setLoading(false);
        notification.error("No bank found");
        setLoading(false);
        setIsEdit(false);
        console.log(error);
        navigate("/bank-manager/bank");
      }
      setLoading(false);
    };
    fetchBank();
  }, [id, navigate, notification]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let response = null;
      if (isEdit) {
        response = await apiPut(`${apiPath.banks}/${id}`, formData);
      } else {
        response = await apiPost(apiPath.banks, formData);
      }
      if (response?.data?.success) {
        setLoading(false);
        notification.success(response?.data?.message);
        navigate("/bank-manager");
      } else {
        notification.error(response?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      notification.error("Something went wrong");
      console.log(error);
    }
  };

  return (
    <div className="bg-white px-2 py-4 flex flex-col gap-4">
      <h1 className="text-2xl font-bold">
        {isEdit ? "Edit Bank" : "Add Bank"}
      </h1>

      <form
        className="flex flex-col gap-4"
        onSubmit={handleSubmit}
        onChange={handleChange}
      >
        <div className="flex  gap-2">
          <Input
            type="text"
            label="Bank Name (English)"
            placeholder="Bank Name (English)"
            name="bankName"
            value={formData.bankName}
            onChange={({ target: { value } }) =>
              setFormData({ ...formData, bankName: value })
            }
            required
          />
          <Input
            type="text"
            label="Bank Name (Arabic)"
            placeholder="Bank Name (Arabic)"
            name="bankNameAr"
            value={formData.bankNameAr}
            onChange={({ target: { value } }) =>
              setFormData({ ...formData, bankNameAr: value })
            }
            required
          />
        </div>
        <div className="flex  gap-2">
          <Input
            label="Account Name (English)"
            placeholder="Account Name (English)"
            name="accountName"
            value={formData.accountName}
            onChange={({ target: { value } }) =>
              setFormData({ ...formData, accountName: value })
            }
            required
          />
          <Input
            type="text"
            label="Account Name (Arabic)"
            placeholder="Account Name (Arabic)"
            name="accountNameAr"
            value={formData.accountNameAr}
            onChange={({ target: { value } }) =>
              setFormData({ ...formData, accountNameAr: value })
            }
            required
          />
        </div>

        <Input
          label="IBAN Number"
          type="text"
          placeholder="IBAN"
          name="ibanNo"
          required
          value={formData.ibanNo}
          onChange={({ target: { value } }) =>
            setFormData({ ...formData, ibanNo: value })
          }
        />
        {/* Status: is currently disabled by backend */}
        {/* <Select
          label="Status"
          name="status"
          required
          value={formData.status}
          onChange={({ target: { value } }) =>
            setFormData({ ...formData, status: value })
          }
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </Select> */}
        <hr className="my-4" />
        <button
          type="submit"
          className={classNames(
            "bg-green-500 text-white px-4 py-2 rounded-md text-nowrap  self-center hover:bg-green-400 hover:shadow-lg hover:cursor-pointer transition-all duration-300",
            loading ? "pointer-events-none" : ""
          )}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={20} />
          ) : isEdit ? (
            "Edit Bank"
          ) : (
            "Add Bank"
          )}
        </button>
      </form>
    </div>
  );
}
